<template>
  <div id="AnnualRevenue">
  </div>
</template>

<script>
import * as echarts from 'echarts'
import resize from '@/components/echarts/mixins/resize'
export default {
  mixins: [resize],
  name: 'AnnualRevenue',
  components: {

  },
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    let that = this
    return {
      nameObj: {
        '年度目标': ['annualTarget', 'annualMatchRatio'],
        '当前目标': ['currentTarget', 'currentMatchRatio']
      },
      chart: null,
      testOptions: {
        title: {
          zlevel: 0,
          text: [
            `{value|0}`
          ].join('\n'),
          top: '40%',
          left: 'center',
          textStyle: {
            rich: {
              value: {
                color: 'white',
                fontSize: 20,
                fontWeight: 'bold'
              }
            }
          }
        },
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: [
          {
            orient: 'vertical',
            x: '0%',
            y: '80%',
            data: ['年度目标'],
            icon: 'circle',
            formatter: function (name, index) {
              var arr = [
                `{b|${name}}`
                // `{a|3000 (200%)}`
              ]
              let val = `{a|0 (0%)}`
              val = `{a|${that.option[that.nameObj[name][0]]} (${(that.option[that.nameObj[name][1]] * 100).toFixed(2)}%)}`
              arr.push(val)
              return arr.join('\n')
            },
            textStyle: {
              rich: {
                a: {
                  fontSize: 10,
                  color: 'white'
                },
                b: {
                  fontSize: 12,
                  color: 'white'
                }
              }
            },
            selectedMode: false
          },
          {
            orient: 'vertical',
            x: '60%',
            y: '80%',
            data: ['当前目标'],
            icon: 'circle',
            formatter: function (name) {
              var arr = [
                `{b|${name}}`
              ]
              let val = `{a|0 (0%)}`
              val = `{a|${that.option[that.nameObj[name][0]]} (${(that.option[that.nameObj[name][1]] * 100).toFixed(2)}%)}`
              arr.push(val)
              return arr.join('\n')
            },
            textStyle: {
              rich: {
                a: {
                  fontSize: 10,
                  color: 'white'
                },
                b: {
                  fontSize: 12,
                  color: 'white'
                }
              }
            }
          }
        ],
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: ['70%', '85%'],
            data: [
              {
                value: 0,
                name: '年度目标',
                itemStyle: {
                  color: '#3e8bff'
                }
              },
              {
                value: 0,
                name: '邮件营销',
                itemStyle: {
                  color: '#48445f'
                }
              }
            ],
            hoverAnimation: false,
            label: { show: false },
            center: ['50%', '45%']
          },
          {
            name: '访问来源',
            type: 'pie',
            radius: ['55%', '70.1%'],
            hoverAnimation: false,
            avoidLabelOverlap: false,
            data: [
              {
                value: 0,
                name: '当前目标',
                itemStyle: {
                  color: '#70b603'
                }
              },
              {
                value: 0,
                name: '邮件营销',
                itemStyle: {
                  color: '#48445f'
                }
              }

            ],
            selectedMode: false,
            label: { show: false },
            center: ['50%', '45%']
          }
        ]
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.initChart()
  },
  watch: {
    'option': {
      handler: function (newValue) {
        if (Object.keys(newValue).length < 0) {}
        if (this.option.totalIncome) {
          this.testOptions.title.text = `{value|${this.option.totalIncome.toFixed(2)}}`
        }
        this.testOptions.series[0].data[0].value = this.option.annualTarget * this.option.annualMatchRatio
        let annualTarget = this.option.totalIncome - this.option.annualTarget
        this.testOptions.series[0].data[1].value = this.option.annualTarget * (1 - this.option.annualMatchRatio)
        this.testOptions.series[1].data[0].value = this.option.currentTarget * this.option.currentMatchRatio
        let current = this.option.totalIncome - this.option.currentTarget
        this.testOptions.series[1].data[1].value = this.option.currentTarget * (1 - this.option.currentMatchRatio)
        this.chart && this.chart.setOption(this.testOptions)
      },
      immediate: true
    }
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById('AnnualRevenue'), {}, { renderer: 'svg' })
      this.chart.setOption(this.testOptions)
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  }
}
</script>

<style scoped lang="stylus">
#AnnualRevenue
  height 9.25rem
</style>
